import GuestService from '../providers/Guest/Guest.service';
import LoadsService from '../providers/Loads/Loads.service';
import { DetailLoadPhoto } from '../redux/api/load/load.model';
import { OrderAttachment } from '../redux/api/orders/orders.model';

class FileUtils {
  static checkDimension = (file: File, minWidth: number, minHeight: number): Promise<void> => {
    return new Promise((resolve, reject) => {
      const img = new Image();

      img.onload = function (): void {
        if (img.width < minWidth || img.height < minHeight) {
          reject();
        } else {
          resolve();
        }
        URL.revokeObjectURL(img.src);
      };

      img.src = URL.createObjectURL(file);
    });
  };

  static getImageSrc = async (id: string): Promise<string> => {
    try {
      const imgBlob = await LoadsService.getAttachmentFile(id);
      return URL.createObjectURL(imgBlob);
    } catch (error) {
      console.error("Couldn't get image for id: ", id);
      return '';
    }
  };

  static getPhotosInBatch = async (photos: OrderAttachment[], batchSize: number): Promise<any> => {
    let results: OrderAttachment[] = [];
    for (let start = 0; start < photos.length; start += batchSize) {
      const end = start + batchSize > photos.length ? photos.length : start + batchSize;

      const slicedResults = await Promise.all(
        photos.slice(start, end).map(async (p) => {
          const newPhoto: OrderAttachment = {
            ...p,
            src: await FileUtils.getImageSrc(p.id)
          };

          return newPhoto;
        })
      );

      results = [...results, ...slicedResults];
    }

    return results;
  };

  static createTemporarySRCThumbnail = (file: File): string => {
    if (!file) return '';

    return URL.createObjectURL(file);
  };

  // function that returns function to link.download file
  static fetchAndDownloadFileLinkClick = (url: string): void => {
    const link = document.createElement('a');
    link.href = url;
    // Append the link to the body (optional, but safer)
    document.body.appendChild(link);
    link.click();
    // Clean up by removing the link
    document.body.removeChild(link);
  };
}

export default FileUtils;
